import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
const ExportCanvasImage = ({ image, width, height, xPos, yPos, rotation }) => {
    const [canvasImage] = useImage(image, 'anonymous');
    return React.createElement(Image, { width: width, height: height, x: xPos, y: yPos, rotation: rotation, image: canvasImage, fill: "transparent" });
};
export default ExportCanvasImage;
